import React from 'react'
const techStack = [
  {
    title: 'Node.js',
    imageUrl: '/nodejs.svg',
  },
  {
    title: 'Express.js',
    imageUrl: '/express.svg',
  },
  {
    title: 'MongoDB',
    imageUrl: '/mongodb.svg',
  },
  {
    title: 'Mongoose',
    imageUrl: '/mongoose.png',
  },
  {
    title: 'React',
    imageUrl: '/react.svg',
  },
  {
    title: 'Redux',
    imageUrl: '/redux.svg',
  },
  {
    title: 'Postman',
    imageUrl: '/postman.png',
  },
  {
    title: 'Git',
    imageUrl: '/git.svg',
  },
];


const Skill = ({ project }) => (
  <div className="max-w-sm rounded overflow-hidden shadow-lg bg-[#edf2f8] hover:bg-white hover:dark:bg-black dark:bg-[#0b111b] p-4 rounded-xl flex flex-col justify-center items-center">
    <img className="rounded-lg w-18 h-16 " src={project?.imageUrl} alt={project?.title} />
    <div className="px-2 py-4 flex justify-center">
    {project?.title}
    </div>
  </div>
);

const Skills = () => {

  
 
  

  return (
    <div
    id="about"
    className="min-h-screen flex flex-col items-center justify-center gap-16 px-6 lg:px-16 bg-white dark:bg-gray-800 text-black dark:text-white"
  >
    <div className='text-3xl font-bold mt-20 text-center'>My <span className='text-red-500 '>Technical</span> Skill <span className='text-red-500 '>Experience</span></div>

    <div className='	'>

    <div className="grid grid-cols-1 sm:grid-cols-2 grid-cols-3 lg:grid-cols-8 gap-4 max-w-[80vw] mx-auto">
  {techStack.map((project, index) => (
    <Skill key={index} project={project} />
  ))}
</div>




      {/* <div>1</div>
      <div>1</div>
      <div>1</div> */}
    </div>

</div>
  )
}

export default Skills